// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  apiUrl: 'https://dev.smartfactory.si/smartbox/api/v1',
  keycloak: {
    // Url of the Identity Provider
    url: 'https://auth.smartfactory.si',

    // Realm
    realm: 'smartbox-chemcolor',

    // The SPA's id.p
    // The SPA is registered with this id at the auth-server
    clientId: 'smartbox-app-dev',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
